import React from "react"
import gameScreen from "../../src/images/screen/gameScreen.png"
import gameTiles from "../../src/images/screen/gameTiles.png"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDoorOpen } from '@fortawesome/free-solid-svg-icons'
import { faGameBoard, faLightbulbOn, faJoystick, faAlienMonster } from '@fortawesome/pro-solid-svg-icons'
import { faHtml5 } from '@fortawesome/free-brands-svg-icons'
import { FormattedMessage, useIntl } from 'gatsby-plugin-intl'

export default function Content() {

    const intl = useIntl();

    return (
        <div>
            <h1 className="mt-[30px] text-center text-[32px] font-bold">{` ${intl.formatMessage({ id: 'below-fold' })} `}</h1>
            <div className="flex text-center mt-[20px]">
                <div className="w-[40%] mx-[5%] text-center">
                    <img className="inline" src={gameScreen} alt="Screen" height="100" />
                    <h2 className="text-[21px] my-[20px] font-bold">{` ${intl.formatMessage({ id: 'text-title-1' })} `}</h2>
                    <span>{` ${intl.formatMessage({ id: 'text-para-1' })} `}</span>
                </div>
                <div className="w-[40%] mx-[5%] text-center">
                    <img className="inline" src={gameTiles} alt="Screen2" height="100" />
                    <h2 className="text-[21px] my-[20px] font-bold">{` ${intl.formatMessage({ id: 'text-title-2' })} `}</h2>
                    <span>{` ${intl.formatMessage({ id: 'text-para-2' })} `}</span>
                </div>
            </div>

            <div className="bg-blueContent">
                <div className="flex text-center mt-[30px]">
                    <div className="m-w-[30%]">
                        <FontAwesomeIcon className="mt-[12px]" size="4x" icon={faGameBoard} />
                        <h3 className="text-[21px] my-[20px] font-bold">{` ${intl.formatMessage({ id: 'text-title-3' })} `}</h3>
                        <span>{` ${intl.formatMessage({ id: 'text-para-3' })} `}</span>
                    </div>
                    <div className="m-w-[30%] ml-[5px]">
                        <FontAwesomeIcon className="mt-[12px]" size="4x" icon={faLightbulbOn} />
                        <h3 className="text-[21px] my-[20px] font-bold">{` ${intl.formatMessage({ id: 'text-title-4' })} `}</h3>
                        <span>{` ${intl.formatMessage({ id: 'text-para-4' })} `}</span>
                    </div>
                    <div className="m-w-[30%] ml-[5px]">
                        <FontAwesomeIcon className="mt-[12px]" size="4x" icon={faDoorOpen} />
                        <h3 className="text-[21px] my-[20px] font-bold">{` ${intl.formatMessage({ id: 'text-title-5' })} `}</h3>
                        <span>{` ${intl.formatMessage({ id: 'text-para-5' })} `}</span>
                    </div>
                </div>
                <div className="flex text-center mt-[20px] pb-[20px]">
                    <div className="m-w-[30%]">
                        <FontAwesomeIcon className="mt-[12px]" size="4x" icon={faHtml5} />
                        <h3 className="text-[21px] my-[20px] font-bold">{` ${intl.formatMessage({ id: 'text-title-6' })} `}</h3>
                        <span>{` ${intl.formatMessage({ id: 'text-para-6' })} `}</span>
                    </div>
                    <div className="m-w-[30%] ml-[5px]">
                        <FontAwesomeIcon className="mt-[12px]" size="4x" icon={faJoystick} />
                        <h3 className="text-[21px] my-[20px] font-bold">{` ${intl.formatMessage({ id: 'text-title-7' })} `}</h3>
                        <span>{` ${intl.formatMessage({ id: 'text-para-7' })} `}</span>
                    </div>
                    <div className="m-w-[30%] ml-[5px]">
                        <FontAwesomeIcon className="mt-[12px]" size="4x" icon={faAlienMonster} />
                        <h3 className="text-[21px] my-[20px] font-bold">{` ${intl.formatMessage({ id: 'text-title-8' })} `}</h3>
                        <span>{` ${intl.formatMessage({ id: 'text-para-8' })} `}</span>
                    </div>
                </div>

                <div className="text-black cursor text-center bottom-1">
                  <a href="https://add.games/privacy-policy/" rel="noreferrer" target="_blank"><FormattedMessage id="compliance-privacy" /></a>
                  <a className="pl-4" href="https://add.games/contact-us/" rel="noreferrer" target="_blank"><FormattedMessage id="compliance-contact" /></a>
                  <a className="pl-4" href="https://add.games/terms-of-use/" rel="noreferrer" target="_blank"><FormattedMessage id="compliance-terms" /></a>
                </div>

            </div>
        </div>

    )
}
